export const present = (value) => typeof value !== 'undefined';
